/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer, useContext } from "react";
import Context from "../context/mainContext";
import { Action, ApiState } from "../misc/api.types";

function useServiceReducer<T, U, V>(
  func: (params: U) => Promise<T>,
  reducer: (state: ApiState<T, U>, action: Action<T> | V) => ApiState<T, U>,
  init: U
): [T | null, boolean, U, React.Dispatch<Action<T> | V>, (val: boolean) => void, () => void] {
  const mainContext = useContext(Context);

  const [{ loading, data, filter, trigger }, dispatch] = useReducer(reducer, {
    loading: true,
    data: null,
    filter: init,
    trigger: false,
  });

  const loader = (value: boolean) => dispatch({ type: "LOADER", value });
  const reload = () => dispatch({ type: "RELOAD" });

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: "INIT" });
      try {
        const response = await func(filter);
        if (!didCancel) {
          dispatch({ type: "SUCCESS", payload: response });
        }
      } catch (error: any) {
        if (!didCancel) {
          mainContext.notifyError(error);
          dispatch({ type: "FAIL" });
        }
      }
    };

    fetchData();
    return () => {
      didCancel = true;
    };
  }, [trigger]);

  return [data, loading, filter, dispatch, loader, reload];
}

export default useServiceReducer;
